import React from 'react';

interface SettingRowProps {
    title: string;
    description: string;
    value: boolean;
    onChange: (value: boolean) => void;
    isLast?: boolean;
    id?: string;
}

export default function SettingRow({ title, description, value, onChange, isLast = false, id }: SettingRowProps) {
    const handleToggle = () => {
        onChange(!value);
    };

    return (
        <div className={`flex items-center justify-between py-5 ${!isLast ? 'border-b border-gray-100 dark:border-gray-700' : ''} px-4`}>
            <div className="flex-1">
                <div className="font-medium text-sm text-gray-900 dark:text-gray-100 cursor-pointer" onClick={handleToggle}>{title}</div>
                <p className="text-sm font-normal text-gray-500 dark:text-gray-400 mt-0.5" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
            <div className="ml-4 lg:ml-24 flex items-center">
                <button
                    id={id}
                    type="button"
                    role="switch"
                    aria-checked={value}
                    onClick={handleToggle}
                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 ${
                        value ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-600'
                    }`}
                >
                    <span className="sr-only">{title}</span>
                    <span
                        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                            value ? 'translate-x-5' : 'translate-x-0'
                        }`}
                    />
                </button>
            </div>
        </div>
    );
}

interface SettingRowSelectProps {
    title: string;
    description: string;
    value: React.ReactNode | null;
    isLast?: boolean;
}

export function SettingRowSelect({ title, description, value, isLast = false }: SettingRowSelectProps) {
    return (
        <div className={`flex items-start justify-between py-5 ${!isLast ? 'border-b border-gray-100 dark:border-gray-700' : ''} px-4`}>
            <div className="flex-1">
                <div className="font-medium text-sm text-gray-900 dark:text-gray-100">{title}</div>
                <p className="text-sm font-normal text-gray-500 dark:text-gray-400 mt-0.5" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
            <div className="ml-4 lg:ml-6 w-48">
                {value ? value : null}
            </div>
        </div>
    );
}
